var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopylink = function SvgCopylink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#F7C144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.916 35.083a8.25 8.25 0 0 0-11.665 0l-5.835 5.833a8.25 8.25 0 1 0 11.668 11.667L37 49.667",
    stroke: "#FBFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.082 40.916a8.25 8.25 0 0 0 11.665 0l5.835-5.832a8.25 8.25 0 1 0-11.667-11.668l-2.917 2.917",
    stroke: "#FBFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCopylink;